import { useState } from 'react';
import type { ChannelId, CrawlingResultStatusFailType } from '@/interfaces/service/appstore/appstore.interface';
import { getSubmitReplyFailMessages } from '@/utils/appstore.util';
import ContentsContainer from '@/components/modal/channel/components/ContentsContainer';

const ErrorContents = ({ channelId, type, children }: { channelId: ChannelId; type: CrawlingResultStatusFailType; children: JSX.Element }) => {
  const [textData, setTextData] = useState(getSubmitReplyFailMessages(type, channelId));

  return (
    <ContentsContainer primaryText={textData.title} secondaryText={textData.desc} isError={true}>
      {children}
    </ContentsContainer>
  );
};

export default ErrorContents;
